/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { DateTimePicker } from '@/components/ui/time-picker/DateTimePicker';
import {
  FormContextType,
  RJSFSchema,
  StrictRJSFSchema,
  WidgetProps,
} from '@rjsf/utils';
import { DateTime } from 'luxon';
import { useEffect } from 'react';

function dateToString(value?: string | Date): string | undefined {
  return typeof value === 'object' && value instanceof Date
    ? value.toISOString()
    : value;
}

function dateFromString(value?: string | Date): Date | undefined {
  if (typeof value === 'string') {
    const date = new Date(value);
    return date;
  }
  return value;
}

function ShDateTimeWidgetImpl<
  T = any,
  S extends StrictRJSFSchema = RJSFSchema,
  F extends FormContextType = any,
>(props: WidgetProps<T, S, F>) {
  const { onChange, value, options } = props;

  useEffect(() => {
    if (options.defaultNow && !value) {
      const now = new Date();
      onChange(dateToString(now));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DateTimePicker
      defaultDate={
        dateFromString(value)
          ? DateTime.fromJSDate(dateFromString(value)!)
          : undefined
      }
      onChange={(value) => {
        const val = value ? value.toJSDate() : undefined;
        return onChange(dateToString(val));
      }}
      disabled={props.readonly}
    ></DateTimePicker>
  );
}

export function ShDateTimeWidget<
  T = any,
  S extends StrictRJSFSchema = RJSFSchema,
  F extends FormContextType = any,
>({ defaultNow }: { defaultNow?: boolean } = {}) {
  return (props: WidgetProps<T, S, F>) =>
    ShDateTimeWidgetImpl<T, S, F>({
      ...props,
      options: { defaultNow, ...props.options },
    });
}
